import { toast } from 'react-toastify';

import {
  fetchCashFlow,
  fetchCashFlowResume,
  fetchAllEstablishmentsFinancialAndUsageResume,
  fetchAllEstablishmentsFinancialAndUsageResumeList,
  fetchAllEstablishmentsFinancialAndUsageResumeReport,
  fetchAllCompletedEstablishmentsFinancialAndUsageResumeReport,
  fetchFinancialResume,
  fetchUsageResume
} from './services';

import {
  setCashFlow,
  setResume,
  setSingleEstablishmentCashFlow,
  setAllEstablishmentCurrentReportId,
  setAllEstablishmentsReportList,
  handleLoading,
  handleResumeLoading
} from './actions';

export const loadCashFlowResume = (userId, startDate, endDate) => dispatch => {
  dispatch(handleResumeLoading(true));

  return fetchCashFlowResume(userId, startDate, endDate)
    .then(({ data }) => {
      dispatch(setResume(data));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleResumeLoading(false)));
}

export const loadCashFlow = (userId, establishmentId, type, month, year) => dispatch => {
  let url = `${userId}/establishment/${establishmentId}/financial/cashflow?&type=${type}&year=${year}`;

  if(type == 'day') {
    url = `${url}&month=${month}`;
  }

  dispatch(handleLoading(true));

  return fetchCashFlow(url)
    .then(({ data }) => {
      const { total, content } = data || {};
      dispatch(setSingleEstablishmentCashFlow(total, content));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadCashFlowByDay = (userId, establishmentId, date) => dispatch => {
  let url = !establishmentId
    ? `${userId}/financial/cashflow/by-day?day=${date}`
    : `${userId}/establishment/${establishmentId}/financial/cashflow/by-day?day=${date}`;

  return fetchCashFlow(url)
    .then(({ data }) => {
      dispatch(setCashFlow({ ...data, date, establishmentId, isDay: true, isMonth: false }));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loadCashFlowByMonth = (userId, establishmentId, date) => dispatch => {
  let url = !establishmentId
    ? `${userId}/financial/cashflow/by-month?month=${date}`
    : `${userId}/establishment/${establishmentId}/financial/cashflow/by-month?month=${date}`;

  return fetchCashFlow(url)
    .then(({ data }) => {
      dispatch(setCashFlow({ ...data, date, establishmentId, isDay: false, isMonth: true }));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loadAllEstablishmentsFinancialAndUsageResume = (userId, params) => dispatch => {
  dispatch(handleLoading(true));

  return fetchAllEstablishmentsFinancialAndUsageResume(userId, params)
    .then(({ data }) => {
      dispatch(setAllEstablishmentCurrentReportId(data?.id));

      toast.warn('Relatório sendo gerado...', {
        toastId: params?.allEstablishmentToastId,
        autoClose: 300000,
        closeOnClick: false,
        closeButton: false,
        onClose: () => dispatch(setAllEstablishmentCurrentReportId(''))
      });
    })
    .catch(() => toast.error('Houve um problema ao iniciar a geração do relatório.'))
    .finally(() => dispatch(handleLoading(false)));
}

export const loadAllEstablishmentsFinancialAndUsageResumeList = userId => dispatch => {
  dispatch(handleLoading(true));

  return fetchAllEstablishmentsFinancialAndUsageResumeList(userId)
    .then(({ data }) => dispatch(setAllEstablishmentsReportList(data)))
    .catch(() => dispatch(setAllEstablishmentsReportList([])))
    .finally(() => dispatch(handleLoading(false)));
}

export const loadAllEstablishmentsFinancialAndUsageResumeReport = (userId, reportId) => dispatch => {
  return fetchAllEstablishmentsFinancialAndUsageResumeReport(userId, reportId)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loadAllCompletedEstablishmentsFinancialAndUsageResumeReport = (userId, reportId) => dispatch => {
  return fetchAllCompletedEstablishmentsFinancialAndUsageResumeReport(userId, reportId)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch(() => {
      return Promise.reject();
    });
}

export const loadFinancialResume = (
  userId,
  establishmentId,
  startDate,
  endDate,
  startTime,
  endTime
) => dispatch => {
  const url = `${userId}/establishment/${establishmentId}/reports/financial?startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}`;

  dispatch(handleLoading(true));

  return fetchFinancialResume(url)
    .then(({ data }) => {
      dispatch(handleLoading(false));

      return {
        ...data,
        startDate,
        endDate
      }
    })
    .catch(() => dispatch(handleLoading(false)));
}

export const loadUsageResume = (
  userId,
  establishmentId,
  startDate,
  endDate,
  startTime,
  endTime
) => dispatch => {
  const url = `${userId}/establishment/${establishmentId}/reports/usage?startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}`;

  dispatch(handleLoading(true));

  return fetchUsageResume(url)
    .then(({ data }) => {
      dispatch(handleLoading(false));

      return {
        resume: data,
        startDate,
        endDate
      }
    })
    .catch(() => dispatch(handleLoading(false)));
}